import React, {Fragment, useMemo} from "react";
import {
  CircularProgress,
  Typography,
  Container,
} from "@mui/material";
import CategoryShowcase from "../components/CategoryShowcase";
import { carouselData, categoryImages } from "../components/data/product";
import HeroCarousel from "../components/HeroCarousel";
import InstagramBanner from "../components/InstagramBanner";
import NewsletterSignup from "../components/NewsletterSignup";
import NovedadesSection from "../components/Novedades";
import ProductShowcase from "../components/ProductShowcase";
import {AppConfigFields, ContactInfoFields} from "../types/appConfigEntities";
import { useHomeProducts } from "../components/hooks/useHomeProducts";
import { Product } from "../types/Product";
import MiddleBannerSection from "../components/MiddleBannerSection";
import { useMiddleBanners } from "../components/hooks/useMiddleBanners";
import { MiddleBannerItem } from "../types/MiddleBannerItem";
import { HttpCache } from "../http/httpCache"
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";


type SnackbarNavState = {
    snackbar?: {
        message: string;
        variant?: "default" | "error" | "success" | "warning" | "info";
    };
};

const Home: React.FC = () => {
    const { showcaseProducts, novedadesProducts, loading, error } = useHomeProducts();
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const state = location.state as SnackbarNavState | null;
        const snack = state?.snackbar;

        if (snack?.message) {
            enqueueSnackbar(snack.message, { variant: snack.variant ?? "default" });

            navigate(location.pathname, { replace: true, state: null });
        }
    }, [enqueueSnackbar, location.pathname, location.state, navigate]);

    const MIN_SHOWCASE_PRODUCTS = 9;

    const normalizeProducts = (products: Product[], minCount: number): Product[] => {


        HttpCache.getPersonTypes();
        HttpCache.getIdentityDocumentTypes();


        if (products.length === 0) return [];

        if (products.length >= minCount) {
            return products;
        }

        const normalized: Product[] = [...products];
        let i = 0;

        while (normalized.length < minCount) {
            normalized.push(products[i % products.length]);
            i++;
        }

        return normalized;
    };

    const normalizedShowcaseProducts = useMemo(
        () => normalizeProducts(showcaseProducts, MIN_SHOWCASE_PRODUCTS),
        [showcaseProducts]
    );


  const { banners: middleBanners } = useMiddleBanners();

  const middleBannerItems: MiddleBannerItem[] = useMemo(() => {
    const items: MiddleBannerItem[] = [];

    //  Banner Instagram
    items.push({
      type: "component",
      key: "instagram-banner",
      component: (
        <InstagramBanner
          handle={window.APP_CONFIG?.[AppConfigFields.ContactData][ContactInfoFields.Instagram] || "mouchi.oficial"}
          url={`https://instagram.com/${window.APP_CONFIG?.[AppConfigFields.ContactData][ContactInfoFields.Instagram] || "mouchi.oficial"}`}
        />
      ),
    });

    // Banners desde DB
    middleBanners.forEach((banner) => {
      items.push({
        type: "image",
        key: banner.id,
        banner,
      });
    });

    return items;
  }, [middleBanners]);


  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Cargando productos...
        </Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h4" color="error" gutterBottom>
          {error}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          No pudimos cargar los productos en este momento.
        </Typography>
      </Container>
    );
  }


    


  const renderProductShowcase = (showcaseProducts: Product[]) => {

    const leftProducts = showcaseProducts.slice(0, 4);
    const rightProducts = showcaseProducts.slice(4, 9);


    
    
    return (
      <Fragment>
          <ProductShowcase
            products={leftProducts}
            title="Productos destacados"
            layout="left-title"
          />
          <ProductShowcase
            products={rightProducts}
            layout="right-title"
          />
      </Fragment>
    );
  }
  
  return (
    <div>
      <HeroCarousel slides={carouselData} />
      
      <CategoryShowcase {...categoryImages} />
      
      {novedadesProducts.length > 0 && (
        <NovedadesSection
          products={novedadesProducts}
          featuredImage="images/categorias-1/categoria3.png"
          title="Novedades"
          subtitle="DESCUBRÍ NUESTROS PRODUCTOS MÁS RECIENTES"
        />
      )}
      
      {/*<InstagramBanner */}
      {/*  handle={window.APP_CONFIG?.[AppConfigFields.ContactData][ContactInfoFields.Instagram] || "mouchi.oficial"}*/}
      {/*  url={`https://instagram.com/${window.APP_CONFIG?.[AppConfigFields.ContactData][ContactInfoFields.Instagram] || "mouchi.oficial"}`}*/}
      {/*/>*/}

      <MiddleBannerSection items={middleBannerItems} />
      
      {normalizedShowcaseProducts.length > 0 &&
        renderProductShowcase(normalizedShowcaseProducts)}

      
      {showcaseProducts.length === 0 && !loading && (
        <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>
            No hay productos disponibles
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Pronto tendremos nuevos productos para vos.
          </Typography>
        </Container>
      )}
      
      <NewsletterSignup />
    </div>
  );
};

export default Home;














